<!-- 认证详情 -->

<template>
  <div class="attesta-details-dialog">
    <w-dialog ref="dialogRef" :title="dialogTitle" width="70%" btnWidth="140px" top="5vh" :hideFooter="true">
      <w-title :title_name="'基本信息'"></w-title>
      <table class="details-table" style="clear: both">
        <tbody>
          <tr>
            <th>项目</th>
            <td colspan="3">{{ infoDatas.base_info.sp_p_name }}</td>

            <th>房号</th>
            <td>{{ infoDatas.base_info.mr_roomnum }}</td>

          </tr>
          <tr>
            <th>面积</th>
            <td>{{ infoDatas.base_info.buildareas }}</td>

            <th>是否交房</th>
            <td>{{ infoDatas.base_info.is_deliver }}</td>

            <th>认证时间</th>
            <td>{{ infoDatas.base_info.mr_create_time }}</td>
          </tr>
        </tbody>
      </table>

      <div class="l-m-t">
        <w-title :title_name="'认证明细'"></w-title>
        <common-table ref="infoTable" tableHeight="200" :columns="tableColumns" :tableData="infoDatas.members"
          :ispaging="false" :tableHeight="300">
          <template #giftPoints="{ row }">
            <template v-if="infoDatas.can_send_integration && authData.indexOf('s_e2299f8969e784853950daf7fd94') != -1">
              <el-button class="theme-font-btn" @click="onGiftBtn(row)">赠送</el-button>
            </template>
          </template>
        </common-table>
      </div>

      <div class="l-m-t">
        <w-title :title_name="'赠送记录'"></w-title>
        <common-table ref="giftRecordTable" tableHeight="200" :columns="giftRecordColumns"
          :tableData="infoDatas.integral_record" :ispaging="false" :tableHeight="400"></common-table>

        <!-- <el-pagination v-model="extraParame.page" :page-sizes="[20, 50, 100, 200, 500]" :page-size="extraParame.limit"
          background layout="total, sizes, prev, pager, next, jumper" :total="extraParame.total"
          @size-change="handleSizeChange" @current-change="handleCurrentChange">
        </el-pagination> -->
      </div>
    </w-dialog>

    <!-- 赠送积分 -->
    <GiftPoints ref="giftRef" @submit="onSubmit"></GiftPoints>
  </div>
</template>

<script>
import { ref, onMounted, nextTick, computed, watch, } from "vue";
import { ElMessage } from "element-plus";
import { RealEstate, } from "@/plugins/api.js";
import { useStore } from "vuex";
import GiftPoints from "./GiftPoints.vue";

export default {
  emits: ["refreshLists", "closeLoading",],
  components: {
    GiftPoints,
  },
  setup(props, { emit }) {
    // 权限
    const store = useStore();
    const menuTokens = computed(() => store.state.menuToken.menuTokens);
    const authData = ref([]);
    watch(
      () => menuTokens.value,
      (data) => {
        if (data.length) {
          authData.value = data;
        }
      },
      {
        deep: true,
        immediate: true,
      }
    );
    const dialogRef = ref(null);  // 对话框
    const currentId = ref('');  // 当前会员数据
    const dialogTitle = ref('详情');  // 标题
    const infoDatas = ref('');  // 详情数据
    const tableRef = ref(null);  // 表格对象
    const extraParame = ref({
      page: 1,
      limit: 20,
      total: 0,
    });
    const membersTable = ref([  // 表格配置
      {
        prop: "m_id",
        label: "会员ID",
      },
      {
        prop: "m_realname",
        label: "会员姓名",
      },
      {
        prop: "m_mobile",
        label: "会员电话",
      },
      {
        prop: "m_level_label",
        label: "会员等级",
      },
      {
        prop: "m_ctime",
        label: "注册时间",
      },
    ]);
    const membersTable1 = ref([  // 表格配置
      {
        prop: "m_id",
        label: "会员ID",
      },
      {
        prop: "m_realname",
        label: "会员姓名",
      },
      {
        prop: "m_mobile",
        label: "会员电话",
      },
      {
        prop: "m_level_label",
        label: "会员等级",
      },
      {
        prop: "m_ctime",
        label: "注册时间",
      },
      {
        type: "operation",
        prop: "",
        label: "操作",
        minWidth: 100,
        bottons: [
          {
            type: "customRender",
            name: "赠送",
            action: "giftPoints",
          },
        ],
      },
    ]);
    const tableColumns = ref([]);  // 表格配置数据
    const infoTable = ref(null);  // 认证明细表格
    const giftRecordTable = ref(null);  // 赠送记录
    const giftRecordColumns = ref([
      {
        prop: "m_id",
        label: "会员ID",
      },
      {
        prop: "m_realname",
        label: "会员姓名",
      },
      {
        prop: "m_mobile",
        label: "会员电话",
      },
      {
        prop: "m_level_label",
        label: "会员等级",
      },
      {
        prop: "mi_source_label",
        label: "类型",
      },
      {
        prop: "mi_integration",
        label: "赠送积分",
      },
      {
        prop: "u_name",
        label: "操作人",
      },
      {
        prop: "created_at",
        label: "操作时间",
        minWidth: 100,
      },
    ]);
    const giftRef = ref(null);  // 赠送积分对象
    /**
     * 
     * 打开对话框
     * 
     * **/
    const openDialog = (id, type) => {
      currentId.value = id;
      if (type == 'info') {
        // 详情
        dialogTitle.value = '详情';
        tableColumns.value = membersTable.value;
        getSunDetails();
      } else {
        // 赠送积分
        dialogTitle.value = '赠送积分';
        tableColumns.value = membersTable1.value;
        getGiftPoints();
      }
    }
    /**
     * 
     * 关闭对话框
     * 
     * **/
    const closeDialog = () => {
      dialogRef.value.close();
    }
    /**
     * 
     * 关闭加载状态
     * 
     * **/
    const closeDialogLoading = () => {
      dialogRef.value.isLoading = false;
    }
    /**
     * 
     * 获取详情数据
     * 
     * **/
    const getSunDetails = () => {
      RealEstate.getSunDetails({ mr_room_id: currentId.value, }).then((res) => {
        emit('closeLoading');
        if (res.Code === 200) {
          infoDatas.value = res.Data;
          dialogRef.value.show();
          nextTick(() => {
            infoTable.value.tableLoad();
            giftRecordTable.value.tableLoad();
          })
        } else {
          ElMessage.error(res.Message);
        }
      });
    }
    /**
     * 
     * 获取赠送积分详情数据
     * 
     * **/
    const getGiftPoints = () => {
      RealEstate.sendIntegral({ mr_room_id: currentId.value,action: 'info', }).then((res) => {
        emit('closeLoading');
        if (res.Code === 200) {
          infoDatas.value = res.Data;
          dialogRef.value.show();
          nextTick(() => {
            infoTable.value.tableLoad();
            giftRecordTable.value.tableLoad();
          })
        } else {
          ElMessage.error(res.Message);
        }
      });
    }
    /**
     * 
     * 赠送按钮
     * 
     * **/
    const onGiftBtn = (row) => {
      giftRef.value.openDialog(row, infoDatas.value);
    }
    /**
     * 
     * 赠送积分-确认赠送
     * 
     * **/
    const onSubmit = (datas) => {
      RealEstate.sendIntegral(datas).then((res) => {
        giftRef.value.closeDialogLoading();
        if (res.Code === 200) {
          getGiftPoints();
          emit('refreshLists');
          ElMessage.success('赠送积分成功！');
          giftRef.value.closeDialog();
        } else {
          ElMessage.error(res.Message);
        }
      });
    }
    /**
     * 
     * 每页数量改变处理
     * 
     * **/
    const handleSizeChange = (number) => {
      extraParame.value.limit = number;
      tableLoad();
    };
    /**
     * 
     * 页码改变处理
     * 
     * **/
    const handleCurrentChange = (number) => {
      extraParame.value.page = number;
      tableLoad();
    };

    onMounted(() => { });

    return {
      openDialog,
      currentId,
      dialogTitle,
      RealEstate,
      dialogRef,
      closeDialog,
      closeDialogLoading,
      getSunDetails,
      tableRef,
      tableColumns,
      infoDatas,
      membersTable,
      membersTable1,
      infoTable,
      giftRecordTable,
      giftRecordColumns,
      onGiftBtn,
      authData,
      giftRef,
      onSubmit,
      extraParame,
      handleSizeChange,
      handleCurrentChange,
      getGiftPoints,
    };
  },
};
</script>

<style lang="scss">
.attesta-details-dialog {
  .details-table th {
    background-color: #F3F4F8;
    color: #92979E;
    width: 120px;
    padding: 0 15px;
    border: 1px solid #e6e8ec !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: 500;
  }

  .details-table {
    width: 100%;
    background-color: #fff;
    border: 1px solid #e6e8ec !important;
    text-align: left;
    font-size: 14px;
  }

  .details-table td {
    padding: 0 15px;
    height: 42px;
    line-height: 42px;
    border: 1px solid #e6e8ec !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #262C30;
    max-width: 300px;
  }
}
</style>